import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce, isEmpty, uniqueId } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PriorEncumbrancesInput",
  props: {
    prompt: {
      type: String,
      required: true
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: null,
      default: () => ({
        option: "",
        text: "",
        textareaValue: "",
        extraComponentText: ""
      })
    },
    explainLabel: {
      type: String,
      default: ""
    },
    extraOptions: {
      type: Array,
      default: () => []
    },
    textareaLabel: {
      type: String,
      default: ""
    },
    showTextarea: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    valuesToDisable: {
      type: Array,
      default: null
    },
    cols: {
      type: String,
      default: "4"
    },
    rows: {
      type: String,
      default: "3"
    },
    resize: {
      type: String,
      default: "none"
    }
  },
  data() {
    return {
      option: this.value.option,
      ifYesAnswer: this.value.ifYesAnswer,
      id: uniqueId(),
      textareaValue: this.value.textareaValue,
      extraComponentText: this.value.extraComponentText || this.value.textareaValue || ""
    };
  },
  computed: {
    mask() {
      return {
        alias: "currency",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        allowMinus: false,
        allowPlus: false,
        groupSeparator: this.groupSeparator,
        autoUnmask: true
      };
    },
    computedExplainLabel() {
      return this.explainLabel || this.$t("global.words.ifYesExplain");
    },
    shouldDisableInput() {
      const valuesToDisable = this.valuesToDisable || ["0", "2"];
      return _includesInstanceProperty(valuesToDisable).call(valuesToDisable, this.option) || isEmpty(this.option);
    }
  },
  watch: {
    value(newValue) {
      if (isEmpty(newValue)) {
        this.option = this.value.option || "0";
        this.ifYesAnswer = this.value.ifYesAnswer;
        this.textareaValue = this.value.textareaValue;
      }
    }
  },
  methods: {
    handleChange: debounce(function () {
      if (this.shouldDisableInput) {
        this.ifYesAnswer = "";
      }
      this.$emit("input", {
        option: this.option,
        ifYesAnswer: this.ifYesAnswer || this.currencyValue || "",
        extraComponentText: this.extraComponentText
      });
    }, 500)
  }
});